import React, { useState } from 'react';
import '../../style/comment.css'

export default function CommentForm({placeholderLabel, submitLabel, handleSubmit, initialText="", hasCancel=false, handleCancel}) {

    const [text, setText] = useState(initialText);
    const isButtonDisabled = text.trim().length === 0

    const handleCommentSubmit = (event) =>{
        handleSubmit(text)
        setText("")
    }

    return (
        <>
        <div>
            <textarea className="comment-form-textarea" placeholder={placeholderLabel} type='textarea' value={text} onChange={e=>setText(e.target.value)} autoFocus={true}/>
            {hasCancel &&<button className='comment-form-button comment-form-cancel' onClick={handleCancel}>Cancel</button>}
            <button className='comment-form-button' disabled={isButtonDisabled} onClick={handleCommentSubmit}>{submitLabel}</button>
        </div>
        </>
    )
}